<template lang="html">
  <div class="row encounter-slide">
    <div v-if="treatment_plan" class="tp-title col-12">
      <h5><strong>{{ treatment_plan.Heading }}</strong></h5>
      <p><em>
        treatment plan prepared 
        <span v-if="pat_name">for {{ pat_name }}</span> 
        <span v-if="treatment_plan.SecDateTEdit"> on {{ treatment_plan.SecDateTEdit | prettyDateShortFromDT }}</span>
      </em></p>
    </div> <!-- /.tp-title -->

    <div class="slide-body col-12">
      <h1 v-if="encounterData.patGoal" class="text-center">Let's Make Sure We're Still Focused On Your Goal</h1>

      <div v-if="decideGoalDisplay(validGoals[0])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>A better looking smile</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Gain more confidence</li>
              <li>Look more healthy</li>
              <li>Take some time for yourself</li>
              <li>Feel & look your best</li>
              <li>Improve your overall health</li>
              <li>Keep your teeth working well</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="decideGoalDisplay(validGoals[1])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>Making teeth last for the long run</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Keep teeth working well into your golden years</li>
              <li>Keep eating favorite foods</li>
              <li>Preserve appearance</li>
              <li>Avoid losing any teeth</li>
              <li>Avoid pain</li>
              <li>Avoid more dental work</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="decideGoalDisplay(validGoals[2])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>Teeth functioning better</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Address active issues making things worse</li>
              <li>Rebuild what you've lost</li>
              <li>Reduce pain</li>
              <li>Enjoy favorite foods again</li>
              <li>Improve your overall health</li>
              <li>Prevent more problems in the future</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="decideGoalDisplay(validGoals[3])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>Avoiding high costs</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Get the care you need at a price you can afford</li>
              <li>Prevent future problems that would be costly to fix</li>
              <li>Avoid more dental work</li>
              <li>Address active issues making things worse</li>
              <li>Improve overall function for stable health</li>
              <li>Make the most of what you have now</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="decideGoalDisplay(validGoals[4])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>Less anxiety about care</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Get a better understanding of overall health to reduce anxiety about "What ifs"</li>
              <li>Avoid pain</li>
              <li>Learn what to expect at appointments</li>
              <li>Understand sedation & anxiety care options</li>
              <li>Get to know your care team</li>
              <li>Establish a care routine</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="decideGoalDisplay(validGoals[5])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>Long term care partner</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Make a plan together to work towards health</li>
              <li>Understand overall health</li>
              <li>Check in together regularly</li>
              <li>Keep teeth working well</li>
              <li>Keep teeth working well into your golden years</li>
              <li>Preserve appearance</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="decideGoalDisplay(validGoals[6])" class="row row-goal align-items-center">
        <div class="col-6">
          <!-- TODO: add full size licensed image -->
          <!-- <img class="img-fluid img-rounded-bevel" src="../assets/img/img-goal-teeth_last.jpg" alt="photo of a woman smiling with sweet treats" /> -->
           <img class="img-fluid img-rounded-bevel img-placeholder" src="" alt="photo placeholder" />
        </div>
        <div class="col-6 d-flex align-items-center">
          <div>
            <h3>Help with current pain</h3>
            <ul class="icon-list icon-list-checks-circle">
              <li>Reduce pain</li>
              <li>Address active issues making things worse</li>
              <li>Rebuild what you've lost</li>
              <li>Get the care you need at a price you can afford</li>
              <li>Understand overall health</li>
              <li>Make a plan together to work towards health</li>
            </ul>
          </div>
        </div>
      </div> <!-- /.row-goal -->

      <div v-if="toggleEditGoal || !encounterData.patGoal" class="box-edit-goal text-center">
        <h3 v-if="!encounterData.patGoal && !newGoal" class="no-goal">
          <i class="fas fa-3x fa-question-circle"></i><br>
          What's most important to you right now?
        </h3>
        <h5 v-if="!encounterData.patGoal && !newGoal">We don't have a goal saved for you, let's pick one:</h5>
        <h3 v-if="!encounterData.patGoal && newGoal">Thanks for telling us! Let's continue with this goal in mind.</h3>
        <h3 v-if="encounterData.patGoal">Change Goal</h3>
        <p class="loading" v-if="savingNewGoal"><i class="far fa-fw fa-pulse fa-spinner"></i> saving, please wait...</p>
        <div v-if="!savingNewGoal" class="form-inline justify-content-center">
          <select v-model="newGoal" class="form-control snug">
            <option disabled :value="null">select one</option>
            <option v-for="(gl, index) in validGoals" :value="gl" :key="gl.replace(' ','_')">{{ gl }}</option>
          </select>
          <button class="btn btn-green mt-3" :disabled="!newGoal" @click="updateGoalInOD">Save &amp; Continue<i class="fas fa-angle-right fa-fw"></i></button>
          <button v-if="encounterData.patGoal && toggleEditGoal" class="btn btn-link" @click="toggleEditGoal=false">cancel</button>
        </div>
      </div> <!-- /.box-edit-goal -->

      <div v-else class="box-confirm-goal text-center">
        <p><button v-if="encounterData.patGoal && toggleEditGoal==false" @click.prevent="markSlideAndForward" class="btn btn-green btn-lg">Yes, That's What I Want!<i class="fas fa-angle-right fa-fw"></i></button></p>
        <p>or <button class="btn btn-link" @click="toggleEditGoal=true">No, Edit Goal</button></p>
      </div>

    </div> <!-- /.slide-body -->

  </div> <!-- /.encounter-slide -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: ['encounterData'],
  data() {
    return {
      validGoals: [
        "A better looking smile",
        "Making teeth last for the long run",
        "Teeth functioning better",
        "Avoiding high costs",
        "Less anxiety about care",
        "Long term care partner",
        "Help with current pain",
      ],
      newGoal: null,
      savingNewGoal: false,
      toggleEditGoal: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
  },
  watch: {
    
  },
  methods: {
    markSlideAndForward() {
      // this.$emit('update-encounter-data', {
      //   slides_completed: [
      //     ...this.encounterData.slides_completed,
      //     this.$route.name,
      //   ],
      // });
      this.$emit('forward')
    },
    passedValidation() {
      // validate data required to update goal
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        console.error('Missing required user or custom claims data');
        return false;
      }
      if (!this.newGoal || this.newGoal === this.encounterData.patGoal) {
        console.error('No new goal selected');
        return false;
      }
      return true;
    },
    decideGoalDisplay(goal) {
      if(
        this.newGoal == goal ||
        (
          !this.newGoal && (this.encounterData.patGoal && this.encounterData.patGoal.length) && (
            this.encounterData.patGoal.includes(goal) ||
            this.encounterData.patGoal === goal
          )
        )
      ) {
        return true;
      }
    },
    updateGoalInOD() {
      if(!this.passedValidation()) {
        return;
      }
      this.savingNewGoal = true;
      const updatePayload = {
        patNum: this.pat_num,
        new_goal_text: this.newGoal,
        locationId: this.custom_claims.authorized_location,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
      };
      const updateGoal = Vue.functions.httpsCallable('updatePatientNote');
      updateGoal(updatePayload)
        .then((result) => {
          // console.log('Goal updated successfully:', result);
          this.savingNewGoal = false;
          // update local encounterData patGoal
          this.$emit('update-encounter-data', { patGoal: this.newGoal });
          // proceed to next step
          // this.$emit('forward');
          this.markSlideAndForward();
        })
        .catch((error) => {
          // do not log PHI in prod
          // console.error('Error updating goal:', error);
          console.error('Error updating goal');
          this.savingNewGoal = false;
        });
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.tp-title {
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid @dark-color;
  margin-bottom: 30px;

  h5,p {
    margin: 0;
  }
}
.encounter-slide {
  padding: 0;

  h3 {
    font-weight: bold;
  }
}
.slide-body {
  padding: 0 30px 30px;
}
.row-goal {
  margin-top: 50px;
  margin-bottom: 50px;
}
.box-edit-goal {
  .btn {
    margin: 0 0 0 10px !important; // override top margin
  }
  h3.no-goal {
    margin-bottom: 10px;
  }
  h5 {
    margin-bottom: 20px;
  }
}
.row-goal + .box-edit-goal {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid @dark-color;
}
.img-placeholder {
  width: 100%;
  height: 400px;
  display: block;
  background-color: @dim-color;
  text-align: center;
}
</style>
